/**
 * Memoized dynamic import for uPlot. Lets vite split uPlot (~50KB gz) +
 * its CSS into a route-lazy chunk so the home page doesn't pay for it.
 */

import type uPlot from 'uplot';

let cached: Promise<typeof uPlot> | null = null;

export function loadUPlot(): Promise<typeof uPlot> {
  if (!cached) {
    cached = (async () => {
      const [mod] = await Promise.all([
        import('uplot'),
        import('uplot/dist/uPlot.min.css'),
      ]);
      return mod.default;
    })();
  }
  return cached;
}
